module.exports = __webpack_public_path__ + "3EF64B3EB3A5398E45E7C6D453192D1Ctrending4.0218a170.png";